import Highlight from "./Highlight.component";

export default Highlight;
